import React from 'react'
import Box from '@material-ui/core/Box'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import { ReactComponent as ListAltIcon } from 'src/mobile/assets/icons/order_my.svg'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import { makeStyles, createStyles } from '@material-ui/core/styles'
// import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import { NavLink, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CUSTOM_BREAKPOINTS } from '../utils/constant'
import { Divider } from '@material-ui/core'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0, 3),
      paddingTop: theme.spacing(8),
      position: 'absolute',
      top: theme.spacing(10),
      // backgroundColor: theme.palette.primary.main,
      width: '290px',
      flexShrink: 0,
      // marginTop: theme.spacing(HEADER_HEIGHT + 8),
      marginBottom: theme.spacing(8),
      // minHeight: theme.spacing(40),
      // maxHeight: theme.spacing(78.75),

      [theme.breakpoints.down(CUSTOM_BREAKPOINTS.md)]: {
        paddingTop: theme.spacing(4),
      },
    },

    listItem: {
      display: 'block',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      color: theme.palette.primary.main,
      '& path': {
        fill: theme.palette.grey[700],
      },
      '& .MuiListItemIcon-root': {
        minWidth: theme.spacing(5),
        color: theme.palette.primary.contrastText,
        [theme.breakpoints.down('md')]: {
          minWidth: 'auto',
        },
      },
      '& .MuiButtonBase-root': {
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          alignItems: 'center',
          padding: theme.spacing(1),
        },
      },
    },
    selected: {
      borderRadius: theme.spacing(10),
      '& .MuiButtonBase-root': {
        backgroundColor: '#F9FAFB',
      },
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
  }),
)

const ProfileSideBar = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const isOrder = useRouteMatch(`/${i18n.language}/profile/order`)
  const isAccount = useRouteMatch(`/${i18n.language}/profile/account`)
  return (
    <Box className={classes.root}>
      {' '}
      <Box fontSize={23} fontWeight={600} mt={-1} mb={4}>
        {t('common.my_account')}
      </Box>
      <Divider />
      <List component="nav" aria-label="profile sidebar">
        <NavLink className={classes.listItem} to="/profile/account" onClick={()=>{console.log('22222')}}>
          <ListItem
            button
            selected={isAccount}
            classes={{
              selected: classes.selected,
            }}
          >
            <ListItemIcon>
              <PersonOutlineOutlinedIcon />
            </ListItemIcon>
            <ListItemText
              primary={t('glossary.account_setting')}
              disableTypography="false"
              style={{ fontWeight: '700', fontSize: '16px' }}
            />
          </ListItem>
        </NavLink>
        <NavLink className={classes.listItem} to="/profile/order" onClick={()=>{console.log('33333')}}>
          <ListItem
            button
            selected={isOrder}
            classes={{
              selected: classes.selected,
            }}
          >
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText
              primary={t('glossary.appointment_order')}
              disableTypography="false"
              style={{ fontWeight: '700', fontSize: '16px' }}
            />
          </ListItem>
        </NavLink>
        {/* <NavLink className={classes.listItem} to="/profile/report" activeClassName={classes.activeListItem}>
        <ListItem button>
          <ListItemIcon>
            <AssignmentIndIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="电子报告" />
        </ListItem>
      </NavLink> */}
      </List>
    </Box>
  )
}

export default ProfileSideBar
